import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureName, FeatureService } from './feature.service';

/**
 * Keeps routes for features this deployment does not have out of reach, so a
 * pasted or bookmarked URL cannot land on a view whose API answers 404.
 */
export function featureGuard(feature: FeatureName): CanActivateFn {
  return () => {
    if (inject(FeatureService).isEnabled(feature)) {
      return true;
    }
    return inject(Router).createUrlTree(['/']);
  };
}
